module.exports = __webpack_public_path__ + "a5a4d9aff9c57d3de6440233eefc2a6f.svg";